(function () {
  var wrap = document.querySelector('.header-wrapper');
  if (!wrap) return;
  var lastY = window.scrollY;
  var threshold = 8;

  function updateNavBottom() {
    var bottom = wrap.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--nav-bottom', (bottom + 8) + 'px');
  }

  function updatePillWidth() {
    var pill = document.querySelector('.header');
    if (!pill) return;
    document.documentElement.style.setProperty('--pill-width', pill.getBoundingClientRect().width + 'px');
  }

  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (y > 10) { wrap.classList.add('is-stuck'); }
    else { wrap.classList.remove('is-stuck'); }
    if (y > lastY + threshold && y > 80) {
      wrap.classList.add('is-hidden');
    } else if (y < lastY - threshold) {
      wrap.classList.remove('is-hidden');
    }
    lastY = y;
    updateNavBottom();
  }, { passive: true });

  window.addEventListener('resize', function () {
    updateNavBottom();
    updatePillWidth();
  }, { passive: true });

  wrap.addEventListener('transitionend', function () {
    updateNavBottom();
    updatePillWidth();
  });

  updateNavBottom();
  updatePillWidth();
})();
